import { Outlet } from 'react-router'

/**
 * AuthLayout — public entry shell for login and signup.
 * Keeps the rebuild's auth surface visually distinct from the application shell.
 */
export function AuthLayout() {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(128,239,128,0.18),_transparent_24%),linear-gradient(160deg,_rgba(3,102,102,0.08),_transparent_45%),linear-gradient(180deg,_#f8f8fd,_#eef5f4)] p-4 text-foreground dark:bg-[radial-gradient(circle_at_top_left,_rgba(128,239,128,0.08),_transparent_22%),linear-gradient(160deg,_rgba(3,102,102,0.18),_transparent_40%),linear-gradient(180deg,_#11181a,_#0d1416)]">
      <div className="mx-auto flex min-h-[calc(100vh-2rem)] w-full max-w-6xl items-center justify-center">
        <div className="grid w-full gap-8 lg:grid-cols-[1.02fr_0.98fr] lg:items-stretch">
          <section className="hidden min-h-[46rem] rounded-[2rem] border border-white/40 bg-[linear-gradient(160deg,_rgba(3,102,102,0.94),_rgba(4,122,122,0.88))] p-8 text-white shadow-2xl shadow-primary/20 lg:flex lg:flex-col lg:justify-center">
            <a
              href="https://m.s360dash.com"
              className="block h-full rounded-[1.5rem] border border-white/15 bg-white/10 p-5 backdrop-blur transition-transform hover:-translate-y-0.5"
            >
              <div className="flex h-full flex-col items-center justify-center text-center">
                <img
                  src="/branding/app-guy-home_688w.avif"
                  srcSet="/branding/app-guy-home_480w.avif 480w, /branding/app-guy-home_688w.avif 688w"
                  sizes="(min-width: 1024px) 34vw, 100vw"
                  alt="360Dash mobile app preview"
                  className="mx-auto w-full max-w-[18rem] object-contain"
                />
                <div className="mt-5 space-y-2 text-center">
                  <p className="text-xl font-semibold">360Dash on the go</p>
                  <p className="mx-auto max-w-md text-sm leading-6 text-white/78">
                    make sure you download our app, details on your dashboard.
                  </p>
                </div>
              </div>
            </a>
          </section>

          <section className="flex min-h-[46rem] items-stretch justify-center">
            <div className="w-full max-w-xl">
              <Outlet />
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}
